import { operateMaxShowLength } from '@/store/dict/config'
import { convertNumber } from '@/utils'
import { getIdentity } from '@/utils/extendFormVaildate'
import { limitMoreZero } from '@/utils/validate.js'
import { Button } from '@qs/ui'

export default function config() {
  const ENUM = {
    OPEN_STATE: {
      2: '开户中',
      3: '已开户',
      4: '开户失败',
    },
    OPEN_STATE_ENUM: {
      onProcess: 2,
      success: 3,
      failed: 4,
    },
    STATE: {
      0: '停用',
      1: '启用',
    },
    STATE_ENUM: {
      disable: 0,
      enable: 1,
    },
  }

  // 法人证件类型枚举
  const legalIdType = {
    1: '身份证',
    3: '港澳回乡证',
    4: '台胞证',
    7: '外国护照',
  }

  // 服务状态枚举
  const serviceState = {
    0: '停用',
    1: '启用',
  }

  const searchBoxColumns = [
    {
      type: 'input',
      label: '子户id',
      key: 'accountId',
      options: {
        clearable: true,
      },
    },
    {
      type: 'input',
      label: '公司主体全称',
      key: 'merchantName',
      options: {
        clearable: true,
      },
    },
    {
      type: 'select',
      label: '开户状态',
      key: 'openState',
      source: [
        { label: '开户中', value: 2 },
        { label: '开户成功', value: 3 },
        { label: '开户失败', value: 4 },
      ],
      options: {
        clearable: true,
      },
    },
    {
      type: 'select',
      label: '启用状态',
      key: 'state',
      source: [
        { label: '停用', value: 0 },
        { label: '启用', value: 1 },
      ],
      options: {
        clearable: true,
      },
    },
  ]
  const tableColumns = [
    {
      name: 'accountId',
      columnProps: {
        prop: 'accountId',
        label: '子户ID',
        minWidth: 150,
      },
    },
    {
      name: 'merchantName',
      columnProps: {
        label: '公司主体全称',
        prop: 'merchantName',
        minWidth: 180,
      },
    },
    // ---
    {
      name: 'bankCardNo',
      columnProps: {
        label: '绑定银行卡卡号',
        prop: 'bankCardNo',
        minWidth: 180,
      },
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement(
            'span',
            {},
            row.bankCardNo ? row.bankCardNo : '未绑卡',
          ),
        )
        return btns
      },
    },
    {
      name: 'bankShortName',
      columnProps: {
        label: '开户银行',
        prop: 'bankShortName',
        minWidth: 180,
      },
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement(
            'span',
            {},
            row.bankShortName ? row.bankShortName : '未绑卡',
          ),
        )
        return btns
      },
    },
    {
      name: 'accountBalance',
      columnProps: {
        label: '账户余额',
        prop: 'accountBalance',
        minWidth: 180,
      },
      render: ({ row }) => {
        const btns = []
        if (!row.bankCardNo) {
          btns.push(<span>未绑卡</span>)
          return btns
        }

        const status =
          row.accountBalance && row.accountBalance.availableAmount !== null
        let btnText = '点击查询余额'
        if (status) {
          btnText = '刷新'
          const frozenAmountStr =
            row.accountBalance.frozenAmount !== null
              ? `（含冻结待分账金额：${convertNumber(
                row.accountBalance.frozenAmount,
              )}元）`
              : ''
          const str = `${convertNumber(
            row.accountBalance.availableAmount,
          )}元 ${frozenAmountStr}`
          btns.push(<span>{str}</span>)
        }

        btns.push(
          <Button
            type="text"
            loading={row.accountBalance.loading}
            onClick={() => this.handleSetRefresh(row)}
          >
            {btnText}
          </Button>,
        )

        return btns
      },
    },
    {
      name: 'licenceNo',
      columnProps: {
        label: '统一社会信用代码证号',
        prop: 'licenceNo',
        minWidth: 180,
      },
    },
    {
      name: 'legalContactName',
      columnProps: {
        label: '法人姓名',
        prop: 'legalContactName',
        minWidth: 150,
      },
    },
    {
      name: 'legalContactMobile',
      columnProps: {
        label: '法人手机号',
        prop: 'legalContactMobile',
        minWidth: 180,
      },
    },
    {
      name: 'legalIdType',
      columnProps: {
        label: '法人证件类型',
        prop: 'legalIdType',
      },
      getText: ({ row }) => legalIdType[row.legalIdType],
    },
    {
      name: 'legalIdNo',
      columnProps: {
        label: '法人证件号码',
        prop: 'legalIdNo',
      },
    },
    {
      name: 'contactName',
      columnProps: {
        label: '联系人姓名',
        prop: 'contactName',
      },
    },
    {
      name: 'contactMobile',
      columnProps: {
        label: '联系人电话',
        prop: 'contactMobile',
      },
    },
    {
      name: 'fullAddress',
      columnProps: {
        label: '联系地址',
        prop: 'fullAddress',
      },
    },
    {
      name: 'openState',
      columnProps: {
        label: '开户状态',
        prop: 'openState',
      },
      getText: ({ row }) => {
        if (row.openState === 2) {
          return '开户中'
        } else if (row.openState === 3) {
          return '已开户'
        } else {
          return '开户失败'
        }
      },
    },
    {
      name: 'state',
      columnProps: {
        label: '启用状态',
        prop: 'state',
      },
      getText: ({ row }) => serviceState[row.state],
    },
    {
      name: 'operate',
      columnProps: {
        label: '操作',
        width: 240,
        fixed: 'right',
      },
      maxShowLength: operateMaxShowLength,
      type: 'operate',
      getOperateList: ({ row }) => {
        const result = []

        // 开户成功后不展示 maintenanceEditAccount
        if (
          this.judgePermission('maintenanceEditAccount') &&
          row.openState !== 3 &&
          row.openState !== 2
        ) {
          result.push({
            name: 'editPartnerAccount',
            label: '编辑',
            action: () => this.editAccount(row),
          })
        }

        // openState 开户状态枚举 2 开户中 3 开户成功 4 开户失败 maintenanceEnableBtn
        if (
          this.judgePermission('maintenanceEnableBtn') &&
          row.state === ENUM.STATE_ENUM.disable &&
          row.openState === 3
        ) {
          result.push({
            name: 'startPartnerAccount',
            label: '启用',
            action: () => this.handleState(row),
          })
        }
        // maintenanceDisableBtn
        if (
          this.judgePermission('maintenanceDisableBtn') &&
          row.state === ENUM.STATE_ENUM.enable &&
          row.openState === 3
        ) {
          result.push({
            name: 'endPartnerAccount',
            label: '停用',
            action: () => this.handleState(row),
          })
        }
        // maintenanceAccountOpen
        if (
          this.judgePermission('maintenanceAccountOpen') &&
          ![2, 3].includes(row.openState)
        ) {
          result.push({
            name: 'accountOpen',
            label: '开户',
            action: () => this.openAccount(row),
          })
        }
        if (
          this.judgePermission('maintenanceBindBankCard') &&
          !row.bankCardNo &&
          row.openState === ENUM.OPEN_STATE_ENUM.success
        ) {
          result.push({
            name: 'maintenanceBindBankCard',
            label: '绑定银行卡',
            action: () => this.bindCardState(row, 'maintenanceBindBankCard', 'bind'),
          })
        }
        // maintenanceReplaceBankCard
        if (
          this.judgePermission('maintenanceReplaceBankCard') &&
          row.bankCardNo &&
          row.openState === ENUM.OPEN_STATE_ENUM.success
        ) {
          result.push({
            name: 'maintenanceReplaceBankCard',
            label: '更换银行卡',
            action: () => this.bindCardState(row, 'maintenanceReplaceBankCard', 'change'),
          })
        }
        // maintenancerecharge
        if (
          this.judgePermission('maintenancerecharge') &&
          row.openState === 3 &&
          row.state === ENUM.STATE_ENUM.enable
        ) {
          result.push({
            name: 'recharge',
            label: '充值',
            action: () => this.openPay(row),
          })
        }

        return result
      },
    },
  ]

  const accountList = [
    {
      el: 'select',
      itemConfig: {
        label: '清分渠道',
        prop: 'channelType',
      },
      elConfig: {
        disabled: true,
        options: {
          label: 'bankName',
          value: 'bankCode',
          list: [],
        },
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '公司主体全称',
        prop: 'merchantName',
      },
      elConfig: {
        placeholder: '请输入',
        maxlength: '100',
        disabled: false,
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '统一社会信用代码证号',
        prop: 'licenceNo',
      },
      elConfig: {
        placeholder: '请输入',
        maxlength: '18',
        disabled: false,
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '法人姓名',
        prop: 'legalContactName',
      },
      elConfig: {
        placeholder: '请输入',
        maxlength: '100',
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '法人手机号',
        prop: 'legalContactMobile',
      },
      elConfig: {
        placeholder: '请输入',
        events: {
          input: (newValue) => {
            limitMoreZero(
              newValue,
              (e) => {
                this.model.legalContactMobile = e
              },
              10,
            )
          },
        },
      },
    },
    {
      el: 'select',
      itemConfig: {
        label: '法人证件类型',
        prop: 'legalIdType',
      },
      elConfig: {
        placeholder: '请选择',
        options: {
          label: 'label',
          value: 'value',
          list: this.dictParseList(legalIdType),
        },
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '法人证件号码',
        prop: 'legalIdNo',
      },
      elConfig: {
        placeholder: '请输入',
        maxlength: '18',
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '联系人姓名',
        prop: 'contactName',
      },
      elConfig: {
        placeholder: '请输入',
        maxlength: '100',
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '联系人电话',
        prop: 'contactMobile',
      },
      elConfig: {
        placeholder: '请输入',
        events: {
          input: (newValue) => {
            limitMoreZero(
              newValue,
              (e) => {
                this.model.contactMobile = e
              },
              10,
            )
          },
        },
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '联系地址',
        prop: 'fullAddress',
      },
      elConfig: {
        placeholder: '请输入',
        maxlength: '100',
      },
    },
  ]

  const accountRules = {
    merchantName: [
      {
        required: true,
        message: '公司主体全称不能为空',
        trigger: 'change',
      },
    ],
    licenceNo: [
      {
        required: true,
        message: '请输入正确的统一社会信用代码证号',
        trigger: 'change',
        validator: (rule, value, callback) => {
          if (value === '') callback('请输入统一社会信用代码证号')
          getIdentity(rule, value, callback)
        },
      },
    ],
    legalContactName: [
      {
        required: true,
        message: '法人姓名不能为空',
        trigger: 'change',
      },
    ],
    legalContactMobile: [
      {
        required: true,
        message: '请输入正确的手机号',
        trigger: 'change',
        // validator: validatePhoneNumber
      },
    ],
    legalIdType: [
      {
        required: true,
        message: '请选择法人证件类型',
        trigger: 'change',
      },
    ],
    legalIdNo: [
      {
        required: true,
        message: '请输入正确的证件号码',
        trigger: 'change',
        validator: (rule, value, callback) => {
          if (value === '') callback('法人证件号码不能为空')
          getIdentity(rule, value, callback)
        },
      },
    ],
    contactName: [
      {
        required: true,
        message: '联系人姓名不能为空',
        trigger: 'change',
      },
    ],
    contactMobile: [
      {
        required: true,
        message: '请输入正确的手机号',
        trigger: 'change',
      },
    ],
    fullAddress: [
      {
        required: true,
        message: '联系地址不能为空',
        trigger: 'change',
      },
    ],
  }

  return {
    ENUM,
    tableColumns,
    searchBoxColumns,
    accountList,
    accountRules,
  }
}
